import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

import styles from "../../assets/css/signupv2.module.css";
import logo from "../../assets/img/signupv2/toi/logo.svg";
import Phone from "../../assets/img/Phone.svg";
import {
  getAuth,
  setUserPhone,
  userSignup,
} from "../../redux/slices/authSlice";
import {
  CompleteRegistration,
  getUtmCampaign,
  getUtmMedium,
  getUtmSource,
  Web_Signup_landed,
  Web_phone_number_added,
} from "../../libs/events";
import { getRecaptcha } from "../../redux/slices/recaptchaSlice";
import { getUserToken } from "../../libs/user";
import { inputFormat, phoneValidation } from "../../utils/validation";
import AppSkeleton from "../../components/Skeletons/AppSkeleton";

function TOIMobileSignup() {
  const [searchParams] = useSearchParams();
  const bankType = searchParams.get("banktype");
  const utm_source = searchParams.get("utm_source");
  const source = searchParams.get("source");

  const phone_number = useSelector((state) => state.auth.toiMobileInput);

  const [mount, setMount] = useState(false);
  const [phoneReadOnly, setPhoneReadOnly] = useState(false);
  const [phone, setPhone] = useState(phone_number);
  const [phoneError, setPhoneError] = useState("");

  const interval0 = useRef();
  const authToken = getUserToken();

  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const fingerprint = useSelector((state) => state.fingerprint);
  const recaptcha = useSelector((state) => state.recaptcha);
  const { loader } = useSelector((state) => state.app);

  const dispatch = useDispatch();
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const signup = (data) => {
    if (validatePhone()) {
      const input = ("+1" + phone).replace(/[- )(]/g, "");
      const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
      dispatch(
        userSignup({
          mobile_number: input,
          refCode: "",
          reCaptcha: recaptcha.data,
          deviceId: fingerprint.data,
          utm_content: userData.txnId || null,
          apiVersion: userData.version || 1,
          signupSource: "toi_js_bridge",
        })
      )
        .unwrap()
        .then((response) => {
          CompleteRegistration();
          navigate(`/verify-otp?bankType=${bankType}`, {
            replace: true,
            state: { utm_source, bankType, source, phone },
          });
          dispatch(getAuth());
          Web_phone_number_added({
            utm_source: getUtmSource(),
          });
        })
        .catch((error) => {
          // dispatch(getRecaptcha({ action: "signup" }));
        });
    }
  };

  const handleChange = (e) => {
    const tempVal = inputFormat(e);
    setPhone(tempVal);
    setPhoneError("");
  };

  const validatePhone = () => {
    const formattedPhone = phoneValidation(phone);
    if (formattedPhone) {
      setPhone(formattedPhone);
      setPhoneError("");
      dispatch(setUserPhone(formattedPhone));
      return true;
    } else {
      setPhoneError("Invalid Phone Number");
      return false;
    }
  };

  // useEffect(() => {
  //   dispatch(getRecaptcha({ action: "signup" }));
  // }, [dispatch]);

  useEffect(() => {
    setMount(true);
    if (mount === true) {
      interval0.current = setInterval(() => {
        const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
        const { username, mobile_number } = userData || {};
        if (username || mobile_number) {
          Web_Signup_landed({
            utm_source: getUtmSource(),
            utm_medium: getUtmMedium(),
            utm_campaign: getUtmCampaign(),
            user_source: null,
            email: username,
            mobile_number,
          });
          clearInterval(interval0.current);
        }
        if (mobile_number) {
          reset({
            phone: mobile_number,
          });
          setPhoneReadOnly(true);
          setPhone(mobile_number);
        }
      }, 500);
    }

    return () => {
      clearInterval(interval0.current);
    };
  }, [mount]);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <img src={logo} />
        </div>

        <div className={styles.mobileContainer}>
          <form id="formmm" onSubmit={handleSubmit(signup)}>
            <div className={styles.headerText}>
              <span>Enter your Phone Number to get Free TOI+</span>
            </div>

            <div className={styles.inputBox}>
              <img src={Phone} alt="phone" className={styles.phone} />
              <div className={styles.phoneField}>
                <div className={styles.inputContainer}>
                  <span className={styles.phoneInput}>+1</span>
                  <input
                    type="tel"
                    id="phone"
                    value={phone}
                    {...register("phone", {
                      required: true,
                    })}
                    className={styles.phoneInput}
                    placeholder="(000) 000-0000"
                    onChange={(e) => handleChange(e)}
                    maxLength={14}
                    readOnly={phoneReadOnly}
                  />
                </div>
                <div className={styles.border}></div>
                {auth.userSignup?.error?.message && !errors.phone && (
                  <span className="errMsg">
                    {auth.userSignup?.error?.message}
                  </span>
                )}
                <span className={`formControlMessage`}>{phoneError}</span>
              </div>
            </div>

            <div className={styles.toiPhonePrivacyText}>
              We may send you SMS for security and login purposes.
            </div>

            <div className={styles.btnContainer}>
              {loader ? (
                <AppSkeleton
                  height={70}
                  width="100%"
                  borderRadius={8}
                  className="footerBoxSkeleton"
                />
              ) : (
                <button className={styles.btnRed}>Continue</button>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default TOIMobileSignup;
